import React from 'react'
import moment from 'moment'

import {
    H5,
    Table,
    FormikInput,
    Divider,
    Col,
    Row,
    Card,
    FormikTextArea,
    Button,
    FormikSimpleSelect,
    MobileListCard,
    AddCard,
    FormikDate
} from '../../../Elements'

import { GuniteHistoryRow } from '../JobForm/SharedGuniteForm'
import { FieldArray } from 'formik'
import { Icon } from '@blueprintjs/core'
import { useMediaQuery } from 'react-responsive'
import { GeneralComments } from './JobDetailForm'

const dividerStyle = {
    marginBottom: '20px'
}

const thirdWidthStyle = {
    maxWidth: '20%',
    display: 'inline-block',
    margin: '5%'
}

const cardStyle = {
    // minWidth: 300
}

const rightAlignTextStyle = {
    textAlign: 'right'
}

export const GuniteDimensionsForm = ({ valuePrefix }) => {
    return (
        <>
            <H5>Dimensions</H5>
            <Table style={{ width: '100%' }}>
                <thead>
                    <tr>
                        <td></td>
                        <td><strong>Builder (Plan)</strong></td>
                        <td><strong>MMG</strong></td>
                    </tr>
                </thead>
                <tbody>
                    <tr>
                        <td><strong>Perimeter</strong></td>
                        <td>
                            <FormikInput
                                name={`${valuePrefix}.plan_perimeter`}
                                placeholder="XXX..."
                            />
                        </td>
                        <td>
                            <FormikInput
                                name={`${valuePrefix}.mmg_perimeter`}
                                placeholder="XXX..."
                            />
                        </td>
                    </tr>
                    <tr>
                        <td><strong>SA</strong></td>
                        <td>
                            <FormikInput
                                name={`${valuePrefix}.plan_sa`}
                                placeholder="XXX..."
                            />
                        </td>
                    </tr>
                </tbody>
            </Table>

            <Divider />

            <FormikInput
                groupStyles={thirdWidthStyle}
                name={`${valuePrefix}.depth_low`}
                label="Depth Low"
                placeholder="XXX..."
            />
            <FormikInput
                groupStyles={thirdWidthStyle}
                name={`${valuePrefix}.depth_mid`}
                label="Depth Mid"
                placeholder="XXX..."
            />
            <FormikInput
                groupStyles={thirdWidthStyle}
                name={`${valuePrefix}.depth_high`}
                label="Depth High"
                placeholder="XXX..."
            />
        </>
    )
}

export const GuniteScheduleForm = ({ valuePrefix }) => {
    return (
        <>
            <H5>Schedule</H5>
            <Row>
                <Col lg={12}>
                    <FormikDate
                        name={`${valuePrefix}.gunite_details.request_date`}
                        label="Date of Request"
                    />
                </Col>
            </Row>
            <Row>
                <Col lg={12}>
                    <FormikDate
                        name={`${valuePrefix}.gunite_details.requested_app_date`}
                        label="Requested Application Date"
                    />
                </Col>
            </Row>
            <Row>
                <Col lg={12}>
                    <FormikDate
                        name={`${valuePrefix}.gunite_details.scheduled_date`}
                        label="Scheduled Date"
                    />
                </Col>
            </Row>
            <Row>
                <Col lg={12}>
                    <FormikDate
                        name={`${valuePrefix}.gunite_details.flash_date`}
                        label="Flash Date"
                    />
                </Col>
            </Row>
        </>
    )
}

const MobileReadOnlyBoulderDetailEntry = ({ boulderDetailEntry }) => (
    <>
        <p>{boulderDetailEntry.status ? boulderDetailEntry.status.name : '(No Status)'}</p>
        <p>{boulderDetailEntry.addition ? boulderDetailEntry.addition.name : '(No Addition)'}</p>
        <p>{boulderDetailEntry.date ? moment(boulderDetailEntry.completed_date).format('MM/DD/YYYY') : '(No Date)'}</p>
        <p style={{ overflow: 'hidden', whiteSpace: 'nowrap', textOverflow: 'ellipsis' }}>{boulderDetailEntry.notes || '(No Notes)'}</p>
    </>
)

const MobileEditBoulderDetailEntry = ({ jobId, jobDetailId, entryId, valuePrefix, idx, jobStatuses, additions }) => (
    <Card>
        <p><Button icon='label' text='View Card' onClick={() => window.open(`/job/${jobId}/${jobDetailId}/boulder/${entryId}`, "_blank")} disabled={!entryId || entryId === -1} style={{ margin: 0 }} /></p>
        <FormikSimpleSelect
            label='Status'
            key={`${valuePrefix}.boulder_details-${idx}-status`}
            name={`${valuePrefix}.boulder_details.${idx}.status`}
            items={jobStatuses}
            nullable
        />
        <FormikSimpleSelect
            label='Addition'
            key={`${valuePrefix}.boulder_details-${idx}-addition`}
            name={`${valuePrefix}.boulder_details.${idx}.addition`}
            items={additions}
            nullable
        />
        <FormikDate
            label='Completed Date'
            key={`${valuePrefix}.boulder_details-${idx}-completed_date`}
            name={`${valuePrefix}.boulder_details.${idx}.completed_date`}
        />
        <FormikTextArea
            label='Notes'
            key={`${valuePrefix}.boulder_details-${idx}-notes`}
            name={`${valuePrefix}.boulder_details.${idx}.notes`}
            placeholder='notes...'
        />
    </Card>
)

export const GuniteWorkDetailsForm = ({ valuePrefix, jobId, values, crews, guniteHistoryTypes, jobOrders, jobStatuses, additions, setFieldValue }) => {
    const defaultNewBoulderDetailEntry = {
        id: -1,
        job_detail_id: values?.id || -1,
    }

    const isMobile = useMediaQuery({ query: '(max-width: 800px)' })
    const smallScreenNonMobile = useMediaQuery({ query: '(max-width: 870px)' })
    return (<>
        <H5> Gunite Work Details </H5>
        <Row>
            <Col lg={6}>
                <FormikInput
                    name={`${valuePrefix}.gunite_details.total_yardage`}
                    label='Total Yardage'
                    key={`gunite_details_yardage_${values.gunite_details.total_yardage}`}
                />
            </Col>
            <Col lg={6}>
                <FormikInput
                    name={`${valuePrefix}.gunite_details.flash_yards`}
                    label="Flash Yards"
                    key={`gunite_details_flash_${values.gunite_details.flash_yards}`}

                />
            </Col>
        </Row>
        <GuniteHistoryRow
            values={values}
            valuePrefix={valuePrefix}
            isMobile={isMobile}
            crews={crews}
            guniteHistoryTypes={guniteHistoryTypes}
            jobOrders={jobOrders}
            setFieldValue={setFieldValue}
            jobStatuses={jobStatuses}
        />
        <Row>
            <Col lg={12}>
                <Divider style={dividerStyle} />
                <H5>Boulder</H5>
                <FieldArray
                    name={`${valuePrefix}.boulder_details`}
                    render={({ push, remove }) => (!isMobile
                        ? <Table
                            style={{ width: '100%' }}>
                            <thead>
                                <tr>
                                    <th>
                                        View Card
                                    </th>
                                    <th>
                                        Status
                                    </th>
                                    <th>
                                        Addition
                                    </th>
                                    <th>
                                        Completed Date
                                    </th>
                                    <th>
                                        Notes
                                    </th>
                                    <th style={rightAlignTextStyle}>
                                        <Button icon='plus' intent='primary' text={smallScreenNonMobile ? '' : 'Add'} onClick={() => push(defaultNewBoulderDetailEntry)} />
                                    </th>
                                </tr>
                            </thead>
                            <tbody>
                                {values.boulder_details && values.boulder_details.map((boulderDetailEntry, idx) => {
                                    return (
                                        <tr key={`${valuePrefix}.boulder_details-${idx}`}>
                                            <td>
                                                <Button icon='label' onClick={() =>
                                                    window.open(`/job/${jobId}/${values.id}/boulder/${boulderDetailEntry.id}`, "_blank")}
                                                    disabled={!boulderDetailEntry.id || boulderDetailEntry.id === -1}
                                                />
                                            </td>
                                            <td
                                                style={{
                                                    minWidth: '12ch',
                                                    padding: smallScreenNonMobile ? 4 : 11
                                                }}
                                            >
                                                <FormikSimpleSelect
                                                    key={`status-${idx}-${boulderDetailEntry.status}`}
                                                    name={`${valuePrefix}.boulder_details.${idx}.status`}
                                                    items={jobStatuses}
                                                    nullable
                                                    style={{
                                                        whiteSpace: 'normal',
                                                        height: 'fit-content',
                                                        minHeight: 30,
                                                        padding: '5px 25px 5px 10px'
                                                    }}
                                                />
                                            </td>
                                            <td
                                                style={{
                                                    minWidth: '15ch',
                                                    padding: smallScreenNonMobile ? 4 : 11
                                                }}
                                            >
                                                <FormikSimpleSelect
                                                    key={`addition-${idx}-${boulderDetailEntry.addition}`}
                                                    name={`${valuePrefix}.boulder_details.${idx}.addition`}
                                                    items={additions}
                                                    nullable
                                                    style={{
                                                        whiteSpace: 'normal',
                                                        height: 'fit-content',
                                                        minHeight: 30,
                                                        padding: '5px 25px 5px 10px'
                                                    }}
                                                />
                                            </td>
                                            <td
                                                style={{
                                                    minWidth: '12ch',
                                                    maxWidth: '12ch',
                                                    padding: smallScreenNonMobile ? 4 : 11
                                                }}
                                            >
                                                <FormikDate
                                                    key={`completed_date-${idx}-${boulderDetailEntry.completed_date}`}
                                                    name={`${valuePrefix}.boulder_details.${idx}.completed_date`}
                                                />
                                            </td>
                                            <td
                                                style={{
                                                    padding: smallScreenNonMobile ? 4 : 11
                                                }}
                                            >
                                                <FormikTextArea
                                                    key={`notes-${idx}-${boulderDetailEntry.notes}`}
                                                    name={`${valuePrefix}.boulder_details.${idx}.notes`}
                                                    placeholder="notes..."
                                                />
                                            </td>
                                            <td style={rightAlignTextStyle}>
                                                <Icon icon='delete' iconSize='25' intent='danger' onClick={() => remove(idx)} />
                                            </td>
                                        </tr>
                                    )
                                })}
                            </tbody>
                        </Table>
                        : <Row>
                            {values.boulder_details && values.boulder_details.map((boulderDetailEntry, idx, ar) => {
                                return (
                                    <Col xs={6}>
                                        <MobileListCard
                                            idx={idx}
                                            onRemove={remove.bind(null, idx)}
                                            dialogTitle='Boulder Detail'
                                            autoOpen={(boulderDetailEntry.createdOnMobile && ((ar.length - 1) === idx) && (boulderDetailEntry.id === -1))}
                                            readOnlyContent={<MobileReadOnlyBoulderDetailEntry boulderDetailEntry={boulderDetailEntry} />}
                                            editViewContent={<MobileEditBoulderDetailEntry idx={idx} valuePrefix={valuePrefix} jobId={jobId} jobDetailId={values.id}
                                                entryId={boulderDetailEntry.id} jobStatuses={jobStatuses} additions={additions}
                                            />}
                                        />
                                    </Col>
                                )
                            })}
                            <Col xs={6}>
                                <AddCard onClick={() => push({ ...defaultNewBoulderDetailEntry, createdOnMobile: true })} />
                            </Col>
                        </Row>
                    )}
                />
            </Col>
        </Row>
    </>
    )
}

export const GuniteNotesForm = ({ valuePrefix, values }) => {
    return (
        <Card style={cardStyle}>
            <Row>
                <Col lg={8}>
                    <GeneralComments
                        name={`${valuePrefix}.general_comments`}
                        generalComments={values?.general_comments}
                        jobDetailId={values.id}
                    />
                </Col>
                <Col lg={3.9}>
                    <FormikTextArea
                        name={`${valuePrefix}.gunite_details.notes`}
                        label="Notes"
                    />
                </Col>

            </Row>
        </Card>
    )
}